function initChatAttach() {
  const fileInput = document.getElementById('js-chat-attache-file');
  const wrapper = document.getElementById('js-chat-wrapper-file');
  const fileNameInput = document.getElementById('js-chat-file-name');
  const removeBtn = document.getElementById('js-chat-remove-btn');
  const chatForm = document.getElementById('js-chat-form');

  if (!fileInput || !wrapper) return;

  function removeURL(e) {
    if (e && e.preventDefault) e.preventDefault();
    fileInput.value = '';
    if (fileNameInput) fileNameInput.value = '';
    wrapper.style.display = 'none';
  }

  function readURL(input) {
    if (input.files && input.files[0]) {
      let filename = input.files[0].name || input.value;
      filename = filename.substring(filename.lastIndexOf('\\') + 1);
      wrapper.removeAttribute('hidden');
      wrapper.style.display = 'flex';
      if (fileNameInput) fileNameInput.value = filename;
    }
  }

  fileInput.addEventListener('change', function () {
    readURL(this);
  });

  if (removeBtn) {
    removeBtn.addEventListener('click', function (event) {
      removeURL(event);
    });
  }

  if (chatForm) {
    chatForm.addEventListener('submit', function () {
      setTimeout(() => {
        removeURL();
      }, 100);
    });
  }
}

document.addEventListener('DOMContentLoaded', initChatAttach);
document.addEventListener('turbolinks:load', initChatAttach);

// Delegated listeners for resilience across dynamic rendering
document.addEventListener('change', function (event) {
  if (event.target && event.target.id === 'js-chat-attache-file') {
    const wrapper = document.getElementById('js-chat-wrapper-file');
    const fileNameInput = document.getElementById('js-chat-file-name');
    if (event.target.files && event.target.files[0]) {
      let filename = event.target.files[0].name || event.target.value;
      filename = filename.substring(filename.lastIndexOf('\\') + 1);
      if (wrapper) {
        wrapper.removeAttribute('hidden');
        wrapper.style.display = 'flex';
      }
      if (fileNameInput) fileNameInput.value = filename;
    }
  }
});

document.addEventListener('click', function (event) {
  const removeBtn = event.target.closest('#js-chat-remove-btn');
  if (removeBtn) {
    event.preventDefault();
    const fileInput = document.getElementById('js-chat-attache-file');
    const wrapper = document.getElementById('js-chat-wrapper-file');
    const fileNameInput = document.getElementById('js-chat-file-name');
    if (fileInput) fileInput.value = '';
    if (fileNameInput) fileNameInput.value = '';
    if (wrapper) wrapper.style.display = 'none';
  }
});
